import { mirrorLightningGroup } from '../mirror';
import { LIGHTNING_SPAWN_1_GROUP } from './spawn-1';
import { LIGHTNING_SPAWN_3_GROUP } from './spawn-3';
import { LIGHTNING_SPAWN_4_GROUP } from './spawn-4';
import { LIGHTNING_SPAWN_5_GROUP } from './spawn-5';
import type { LightningConfig } from './types';

/**
 * THE AUTHORED LOOK: the four tuned groups, each paired with its mirror on
 * the other side of the engine, assembled. This is what the lab
 * opens on and the config the strike should ship with.
 *
 * Counterpart to LIGHTNING_CONFIG in ./index.ts, whose five groups are
 * procedural authoring SEEDS -- evenly spaced positions and generated
 * keyframes, useful for starting a new strike and nothing else. Everything
 * here came off the lab's timeline by hand.
 *
 * Each group lives in its own file so one can be re-pasted from a fresh
 * "Copy config" export without touching the others.
 *
 * The four run 1.05s, 1.37s, 1.08s and 1.45s -- see each file's header.
 * ALL EIGHT OPEN ON ONE FRAME, then play CONTINUOUSLY: each group rests on
 * its own between plays, so the strikes drift into a staggered run that
 * never leaves fewer than three groups alight. See advanceCycle in
 * ../scheduler.ts.
 */
export const LIGHTNING_AUTHORED_CONFIG: LightningConfig = {
  gapMin: 0.2,
  gapMax: 0.7,
  staggerMin: 0,
  staggerMax: 0,
  cycleShape: 'together',
  continuous: { minLive: 3 },
  groups: [
    LIGHTNING_SPAWN_1_GROUP,
    LIGHTNING_SPAWN_3_GROUP,
    LIGHTNING_SPAWN_4_GROUP,
    LIGHTNING_SPAWN_5_GROUP,
  ].flatMap((group) => [group, mirrorLightningGroup(group)]),
};
